import React, { useEffect, useState } from 'react';
import Link from "next/link";
import Image from "next/image";
import styles from "../styles/Home.module.css"; // ✅ Import CSS Module correctly
import Hero from "../assets/hero_image.png";
import Butterfly from "../assets/bg-butterfly.png";
import Partnership from "../assets/partnership.png";
import IndexImage1 from "../assets/index_image_1.jpg";
import IndexImage2 from "../assets/index_image_2.png";
import IndexImage3 from "../assets/index_image_3.png";
import Card from "../componets/partnerCard";
import Testimonial from "../assets/testimonial.png"
import ProjectCard from "../componets/projectCard"
import logo from '../assets/logo.png';
import CounterWithText from "../componets/counter";
import EmblaCarousel from '../componets/testimonails';
import Client from "../assets/client.svg"
import Impact from '../componets/impact';
import { useSelector } from "react-redux";
import apiService from "./api/apiService";
import { generateAuthToken } from "./api/utils";
import dayjs from 'dayjs';
import { messaging, getToken, onMessage } from "../lib/firebase";
import "react-toastify/dist/ReactToastify.css"; // Import Toastify CSS
import SEO from '../componets/SEO';
import CheckoutButton from '../componets/CheckoutButton';


// title json
import enTitle from "../../locales/en/title.json";
import esTitle from "../../locales/es/title.json";

// Languages banner
import enBanner from "../../locales/en/banner.json";
import esBanner from "../../locales/es/banner.json";

// Languages about
import enAbout from "../../locales/en/about.json";
import esAbout from "../../locales/es/about.json";

// Langauges Partnership program
import enPartner from "../../locales/en/partnership.json";
import esPartner from "../../locales/es/partnership.json";

// Testimonials
import enTestimonials from '../../locales/en/testimonials.json'
import esTestimonials from '../../locales/es/testimonials.json'

// Event
import enevent from '../../locales/en/event.json'
import esevent from '../../locales/es/event.json'
import { parseJSON, set } from 'date-fns';
import Loader from '../componets/loader';
import { toast } from 'react-toastify';
import CommunityCard from '../componets/communityCard';
import SupporterModal from '../componets/paymentPopup';
import PaymentPopup from '../componets/paymentPopup';
import CreateAccountPopup from '../componets/registerpopup';

export default function Home({ seo }) {


  const [beneficiaries, setBeneficiaries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [projectsList, setProjectsList] = useState([]);
  const [score, Setscore] = useState([]);
  const [beforeAfterData, setBeforeAfterData] = useState([]);
  const [fectchEvent, setFectchEvent] = useState([]);

  const Languages = useSelector((state) => state.auth.lang);
  const [bannerContent, setBannerContent] = useState(enBanner);
  const [aboutContent, setaboutContent] = useState(enAbout);
  const [partnerContent, setPartnerContent] = useState(enPartner);
  const [testimonialContent, setTestimonialContent] = useState(enTestimonials);
  const [titleContent, setTitleContent] = useState(enTitle);
  const [eventContent, setEventContent] = useState(enevent);
  const [communityArray, setCommunityArray] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [showRegister, setShowRegister] = useState(false);

  const [Spinngloading, setSpinngLoading] = useState(false);

  const [deviceToken, setDeviceToken] = useState("");

  const loginUserId = useSelector((state) => state.auth.userId);

  const isValidValue = (value) => {
    return value !== null && value !== undefined && value !== "";
  };

  useEffect(() => {
    // Update content when language changes
    setBannerContent(Languages === 'es' ? esBanner : enBanner);
    setaboutContent(Languages === 'es' ? esAbout : enAbout);
    setPartnerContent(Languages === 'es' ? esPartner : enPartner);
    setTestimonialContent(Languages === 'es' ? esTestimonials : enTestimonials);
    setTitleContent(Languages === 'es' ? esTitle : enTitle);
    setEventContent(Languages === 'es' ? esevent : enevent);
  }, [Languages]);


  useEffect(() => {
    const fetchAllData = async () => {
      try {
        setSpinngLoading(true);
        await Promise.all([
          getBeneficiary(),
          fetchProjects(),
          beneficiaryScoret(),
          fetchBeforeAfterReport(),
          fectchEvents(),
          getpricing()
        ]);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setSpinngLoading(false);
      }
    };

    fetchAllData();
  }, [Languages]);

  const getBeneficiary = async (reset = false) => {
    setLoading(true);
    try {
      const authToken = generateAuthToken("BENEFICIARIES_LIST");
      const requestData = {
        auth_token: authToken,
        category_id: 'All',
        per_page: 8,
        is_home_page: true
      };

      const response = await apiService.post(`/beneficiaries?page=1}`, requestData);

      if (response.success) {
        const newBeneficiaries = response?.result?.data || [];
        const prayerPartner = {
          id: beneficiaries.length + 1, // dynamic id
          name: bannerContent?.homepage?.Partner?.second_title,
          type: "Discover",
          description: bannerContent?.homepage?.Partner?.second_button,
        }
        // Insert at index 4
        newBeneficiaries.splice(4, 0, prayerPartner);
        setBeneficiaries(newBeneficiaries);

      } else {
        setBeneficiaries([]);

      }
    } catch (error) {
      console.error("Error fetching beneficiaries:", error);
      toast.error(error.message, { position: "top-right", autoClose: 3000 });
    }
    setLoading(false);
  };

  const getpricing = async () => {
    try {
      const authToken = generateAuthToken('COMMUNITY_PARTNERS'); // Use email or another unique value
      const requestData = {
        auth_token: authToken,
      };
      const response = await apiService.post("/community_partners", requestData);

      if (response.success) {
        const amounts = response?.data ? [...response.data] : [];

        // move first item to last
        if (amounts.length > 0) {
          amounts.push(amounts.shift());
        }

        setCommunityArray(Array.isArray(amounts) ? amounts : []);

      }
    } catch (error) {
      console.error("Registration Error:", error);
      // Fix: Display error message string instead of entire error object
      const errorMessage = error?.message || error?.response?.data?.message || "Failed to load pricing data";
      toast.error(errorMessage, { position: "top-right", autoClose: 3000 });
    }
  };

  const fetchProjects = async () => {
    setLoading(true);
    try {
      const authToken = generateAuthToken('PROJECTS_LIST');
      const requestData = {
        auth_token: authToken,
        category_id: "All",
        per_page: 3,
      };

      const response = await apiService.post(`/projects?page=1}`, requestData);

      if (response.success && Array.isArray(response?.result?.data)) {
        const newProject = response?.result?.data || [];
        setProjectsList(newProject);
      } else {
        console.error("Projects API error:", response?.message);
        setProjectsList([]);
      }
    } catch (error) {
      console.error("Projects API error:", error);
      setProjectsList([]);
    }
    setLoading(false);
  };

  const beneficiaryScoret = async () => {

    setLoading(true);
    try {
      const authToken = generateAuthToken('BENEFICIARY_OVERALL_SCORE');
      const requestData = {
        auth_token: authToken,
      };

      const response = await apiService.post(`/beneficiary_overall_score`, requestData);

      if (response.success && Array.isArray(response?.result)) {
        Setscore(response?.result || []);
      } else {
        console.error("Projects API error:", response?.message);
        Setscore([]);
      }
    } catch (error) {
      console.error("Projects API error:", error);
      Setscore([]);
    }
    setLoading(false);
  };

  const fetchBeforeAfterReport = async () => {

    setLoading(true);
    try {
      const authToken = generateAuthToken('BENEFICIARY_ENHANCE_REPORTS');
      const requestData = {
        auth_token: authToken,
      };

      const response = await apiService.post(`/beneficiary_enhance_reports`, requestData);

      if (response.success && Array.isArray(response?.result)) {
        setBeforeAfterData(response?.result || []);
      } else {
        console.error("Projects API error:", response?.message);
        setBeforeAfterData([]);
      }
    } catch (error) {
      console.error("Projects API error:", error);
      setBeforeAfterData([]);
    }
    setLoading(false);
  }

  const fectchEvents = async () => {

    setLoading(true);
    try {
      const authToken = generateAuthToken('EVENTS');
      const requestData = {
        auth_token: authToken,
      };

      const response = await apiService.post(`/events`, requestData);

      if (response.success) {
        setFectchEvent(response?.result?.data || []);
      } else {
        console.error("Event API error:", response?.message);
        setFectchEvent([]);
      }
    } catch (error) {
      console.error("Event API error:", error);
      setFectchEvent([]);
    }
    setLoading(false);
  }

  const OPTIONS = { direction: 'ltl', loop: true }
  const SLIDE_COUNT = 5
  const SLIDES = Array.from(Array(SLIDE_COUNT).keys())

  return (
    <>

      <SEO
        title={seo.title}
        description={seo.description}
        url={seo.url}
        canonical={seo.canonical}
        image={seo.image}
      />

      <Loader show={Spinngloading} />
      {/* <main>
            <h1>Firebase Push Notification</h1>
            <p>Your token:</p>
            <code style={{ wordBreak: "break-all" }}>{deviceToken}</code>
          </main> */}
      {/* <CheckoutButton/> */}
      {/* Hero Banner */}
      <section id="hero" className={`${styles.hero} section dark-background container header-space`}>
        <div className="row align-items-center flex-column-reverse flex-lg-row">
          <div className="col-12 col-lg-6">
            <div
              className="text-center text-lg-start"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <h1 className={`${styles.mobilefont} mb-5`}>{bannerContent.headline}</h1>
              <Link
                href="#"
                onClick={() => setShowRegister(true)}
                className="cta-btn align-items-center gap-1"
              >
                <span>{bannerContent.button}</span>
                <i className="bi bi-caret-right-fill" style={{ fontSize: '7px' }}></i>
              </Link>
            </div>
          </div>

          <div className="col-12 col-lg-6">
            <div className="hero_image text-center">
              <Image
                src={Hero}
                width={600}
                height={400}
                className={`${styles.heroImg}`}
                alt="Banner Image"
                priority
                style={{
                  width: '100%',
                  height: 'auto',
                  maxWidth: '100%',
                }}
              />
            </div>
          </div>
        </div>

      </section>


      {/* Impact Reports */}
      {score.length > 0 && (
        <section className="stats-section py-4">
          <div className="container">
            <div className="stats-box ">
              {score.map((scores) => (
                <React.Fragment key={scores.id}>
                  {isValidValue(scores.supported_childrens_count) && (
                    <div className="stat-item text-center">
                      <CounterWithText
                        counter={scores.supported_childrens_count}
                        type=""
                        title={partnerContent?.page?.count?.childrenSupported}
                      />
                    </div>
                  )}

                  {isValidValue(scores.student_grade_level) && (
                    <div className="stat-item text-center">
                      <CounterWithText
                        counter={scores.student_grade_level}
                        type=""
                        title={partnerContent?.page?.count?.studentsAdvanced}
                      />
                    </div>
                  )}

                  {isValidValue(scores.total_fund_received) && (
                    <div className="stat-item text-center">
                      <CounterWithText
                        counter={scores.total_fund_received}
                        type=""
                        title={partnerContent?.page?.count?.fundsReceived}
                      />
                    </div>
                  )}

                  {isValidValue(scores.total_meals_served) && (
                    <div className="stat-item text-center">
                      <CounterWithText
                        counter={scores.total_meals_served}
                        type=""
                        title={partnerContent?.page?.count?.mealsServed}
                      />
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        </section>
      )}



      {/* Partnership Programs */}
      <section className="section mt-0 partnership-section position-relative">
        <div className="container position-relative ">
          <Image
            src={Butterfly}
            alt="butterfly"
            className="butterflyBG"
            sizes="(max-width: 767px) 100vw, 658px"
            priority={false}
          />
          <div class="stats-section text-section  py-2 py-md-5 position-relative lavender">
            <div class="container text-center">
              <div class="row row justify-content-center">
                <div class="col-12 col-lg-9">
                  <h2 className='center'>
                    {bannerContent?.homepage?.Partner?.content}
                  </h2>
                </div>
              </div>
              <div class="circle-bg"></div>
            </div>
          </div>

          <div className="row g-5 align-items-center position-relative partnership-section teal mt-5 mt-md-0">
            <div className="col-12 col-lg-6 px-3 px-md-4">
              <div className="partnership-content position-relative">
                <div className={`${styles.circle}`}></div>
                <p className="heading-block-sub text-center text-lg-start ">
                  {bannerContent?.homepage?.Partner?.subtitle}
                </p>
                <h2 className='text-center text-lg-start center'>{bannerContent?.homepage?.Partner?.title} </h2>
                <p className="large pb-3 text-center text-lg-start">
                  {bannerContent?.homepage?.Partner?.description}
                </p>
                <div className="d-flex justify-content-center justify-content-xl-start">
                  <Link href="/partnership" className="secondary-btn text-center text-xl-start fs-14">
                    {bannerContent?.homepage?.Partner?.button} <i className="bi bi-chevron-right"></i>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6 px-3 px-md-4">
              <div className="row g-2 g-sm-3">
                {beneficiaries?.map((item, index) => (
                  <div key={item.id} className="col-sm-4 col-6">
                    {item.type === "Discover" ? (
                      <div className={`${styles.discovercard} lh-sm`}>
                        {item.name}
                        <Link className='fs-6 mt-4' href="/partnership">
                          {item.description} <i className="bi bi-caret-right-fill" style={{ fontSize: '7px' }}></i>
                        </Link>
                      </div>
                    ) : (
                      <div className="profile-card">
                        <Link href={`/partnership-details?slug=${item.slug_name}&title=${item.name}`} className={styles.benGrid}>
                          <div className={`${styles.agebadge}`}>{item.age}   {bannerContent?.homepage?.Partner?.years_old}</div>
                          <Image src={item.image} alt={item.name} />
                          <div className={`${styles.name} mt-2`}>{item.name}</div>
                        </Link>
                      </div>
                    )}
                  </div>
                ))}
              </div>

            </div>
          </div>
        </div>
      </section>
      {/*  Community partner */}
      <section className="section mt-0 position-relative">
        <div className="container position-relative ">

          <div className="row align-items-center position-relative flex-column-reverse flex-lg-row">
            <div className="col-12 col-lg-6 p-0  px-md-4 ">
              <div class="row g-3">
                {communityArray?.map((item) => (
                  <div className="col-12 col-sm-6" key={item.id}>
                    <CommunityCard {...item} onOpen={setSelectedCard} />
                  </div>
                ))}
                {selectedCard && (
                  <PaymentPopup
                    {...selectedCard}
                    onClose={() => setSelectedCard(null)}
                  />
                )}

              </div>
            </div>
            <div className="col-12 col-lg-6 mb-5 mb-lg-0 px-3 px-md-4">
              <div className="partnership-content position-relative text-center text-lg-start">
                <div className={`${styles.circle}`}></div>
                <p className="heading-block-sub">
                  {bannerContent?.homepage?.Community?.content}
                </p>
                <h2 className='center'> {bannerContent?.homepage?.Community?.title} </h2>
                <p className="large pb-3">
                  {bannerContent?.homepage?.Community?.description}
                </p>
                <div className="d-flex justify-content-center justify-content-xl-start">
                  <Link href="/community-partnership" className="secondary-btn text-center text-xl-start font-secondary fs-14">
                    {bannerContent?.homepage?.Community?.button} <i className="bi bi-chevron-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* project */}
      <section className="section mt-0 position-relative lavender">
        <div className="container position-relative ">

          <div className="row g-5 align-items-center position-relative">
            <div className="col-12 col-lg-6">
              <div className="partnership-content position-relative text-center text-lg-start">
                <div className={`${styles.circle}`}></div>
                <p className="heading-block-sub">
                  {bannerContent?.homepage?.Project?.content}
                </p>
                <h2>{bannerContent?.homepage?.Project?.title}</h2>
                <p class="large pb-3">
                  {bannerContent?.homepage?.Project?.description}
                </p>
                <div className="d-flex justify-content-center justify-content-xl-start">
                  <Link href="/projects" className="secondary-btn text-center text-xl-start font-secondary fs-14">
                    {bannerContent?.homepage?.Project?.button} <i className="bi bi-chevron-right"></i>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6 p-0  px-md-4">
              <div class="row g-3">

                {projectsList?.map((project) => (
                  <div className="col-12 col-sm-6 col-md-6 col-lg-12" key={project.id}>
                    <ProjectCard
                      image={project.image}
                      category={project.category_name}
                      name={project.project_name}
                      description={project.project_description}
                      percentage={project.fund_received_percentage}
                      collectedAmount={project.fund_received}
                      balanceAmount={project.total_fund_raised}
                      buttonText={partnerContent?.Donate_Now}
                      slug={project.slug_name}
                      project_name={project.project_name}
                      project_id={project.id}
                      onOpen={setSelectedCard}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* SGC */}
      <section className={`${styles.greybackgroundsection} testimonials`}>
        <div className="container aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">

          <div className="row gy-4 align-items-center flex-column-reverse flex-lg-row">
            <div className="col-lg-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
              <div className="row gy-4">

                <div className="col-lg-12">
                  <div className="info-item d-flex flex-column justify-content-center align-items-center aos-init aos-animate" data-aos="fade-up" data-aos-delay="200">
                    <Image src={IndexImage1} layout="responsive" alt="gallery image"  className='borderRadius-13' />
                  </div>
                </div><div className="col">
                  <div className="info-item d-flex flex-column justify-content-center align-items-center aos-init aos-animate" data-aos="fade-up" data-aos-delay="300">
                    <Image src={IndexImage2} width={100} height={50} layout="responsive" alt="gallery image" className='borderRadius-13' />
                  </div>
                </div>



                <div className="col">
                  <div className="info-item d-flex flex-column justify-content-center align-items-center aos-init aos-animate" data-aos="fade-up" data-aos-delay="400">
                    <Image src={IndexImage3} width={100} height={50} layout="responsive" alt="gallery image" />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 text-center text-lg-start">
              <div className="sgc-section px-3 px-md-4">
                <p className="heading-block-sub">
                  {bannerContent?.homepage?.Intro?.content}
                </p>
                <h2> {bannerContent?.homepage?.Intro?.title}  </h2>
                <p className="large pb-3">
                  {bannerContent?.homepage?.Intro?.subtitle}
                </p>
                <p className="large pb-3 ">
                  {bannerContent?.homepage?.Intro?.description}
                </p>
                <div className="d-flex justify-content-center justify-content-xl-start">
                  <Link href="/about" className="secondary-btn text-center text-xl-start font-secondary fs-14">
                    {bannerContent?.homepage?.Intro?.button}<i className="bi bi-chevron-right"></i>
                  </Link>
                </div>

              </div>
            </div>

          </div>

        </div>
      </section>

      {showRegister && <CreateAccountPopup onClose={() => setShowRegister(false)} />}
    </>

  );
}


// This ensures SEO tags are rendered on server
export async function getServerSideProps() {
  return {
    props: {
      seo: {
        title: "Home – Serving God's Children",
        description:
          "Join us in bringing hope and support to underprivileged children and families in Guatemala.",
        url: "https://servinggodschildren.com/",
        canonical: "https://servinggodschildren.com/",
        image: "https://prod.servinggodschildren.com/logo.png"
      }
    }
  };
}